import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TeamContext } from "../Contexts/TeamContext";
import Alert from "../components/Alert";

const TeamEditForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { team, updateTeamMember } = useContext(TeamContext);

  const member = team.find((m) => m._id === id);
  
  const [name, setName] = useState(member?.name || "");
  const [position, setPosition] = useState(member?.position || "");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(member?.image ? `${member.image}` : "");
  const [alert, setAlert] = useState({status: "", message: ""});

  useEffect(() => {
    if (image) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(image);
    } else if (member?.image) {
      setImagePreview(`${member.image}`);
    }
  }, [image, member?.image]);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setImage(file);
  };

  const handleCancel = () => {
    navigate('/admin/view/members');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("name", name);
    formData.append("position", position);
    if (image) {
      formData.append("image", image);
    }

    try {
      await updateTeamMember(id, formData);
      // console.log("Team member updated successfully");
      setAlert({ status: "success", message: "Team member updated successfully!" });
      setTimeout(() => {
        navigate("/admin/view/members");
      }, 2000);
    } catch (error) {
      const errorMessage = error.message || "Failed to update team member.";
      setAlert({ status: "error", message: errorMessage });
    }
  };

  return (
    <div className="bg-gray-100 py-10">
        {alert.message && (
            <Alert
              status={alert.status}
              message={alert.message}
              onClose={() => setAlert({ status: "", message: "" })}
            />
          )}
      <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold mb-6 text-gray-800">Update Team Member Form</h1>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="mb-4">
            <label htmlFor="position" className="block text-gray-700 font-medium mb-2">Position</label>
            <input
              type="text"
              id="position"
              name="position"
              value={position}
              onChange={(e) => setPosition(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
              required
            />
          </div>

          <div className="mb-4">
            <label htmlFor="image" className="block text-gray-700 font-medium mb-2">Image</label>
            {imagePreview && (
              <img
                src={imagePreview}
                alt="Preview"
                className="mb-4 w-40 h-40 object-cover rounded-lg"
              />
            )}
            <input
              type="file"
              id="image"
              name="image"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
              onChange={handleImageChange}
            />
          </div>

          <div className="flex space-x-4">
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600"
            >
              Submit
            </button>
            <button
              type="button"
              onClick={handleCancel}
              className="px-4 py-2 bg-gray-600 text-white rounded-lg shadow hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-600"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TeamEditForm;
